var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "-3 -3 36.00 36.00",
    xmlSpace: "preserve",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.01,10.99C1.795,10.99,0,12.786,0,15c0,2.215,1.795,4.01,4.01,4.01c2.215,0,4.01-1.795,4.01-4.01 C8.02,12.786,6.225,10.99,4.01,10.99z M4.01,17.229c-1.229,0-2.228-1-2.228-2.229c0-1.229,0.999-2.228,2.228-2.228 S6.238,13.771,6.238,15C6.238,16.229,5.238,17.229,4.01,17.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.99c-2.215,0-4.01,1.795-4.01,4.01s1.795,4.01,4.01,4.01s4.01-1.795,4.01-4.01C19.01,12.786,17.215,10.99,15,10.99z M15,17.229c-1.229,0-2.228-1-2.228-2.229c0-1.229,0.999-2.228,2.228-2.228c1.229,0,2.229,0.999,2.229,2.228 C17.229,16.229,16.229,17.229,15,17.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.99,10.99c-2.215,0-4.01,1.795-4.01,4.01s1.795,4.01,4.01,4.01S30,17.215,30,15C30,12.786,28.205,10.99,25.99,10.99z M25.99,17.229c-1.229,0-2.227-1-2.227-2.229c0-1.229,0.998-2.228,2.227-2.228s2.228,0.999,2.228,2.228 C28.218,16.229,27.218,17.229,25.99,17.229z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.36a61c7d9e2b3f193871069bb2fbe4fb.svg";
export { ForwardRef as ReactComponent };